export class ImportConfirmation {
  importId?: number;
  excludedItemIds?: number[];

  constructor(importId: number, excludedItemIds: number[]) {
    this.importId = importId;
    this.excludedItemIds = excludedItemIds;
  }
}
